import { BlindsHorizontalIcon } from './BlindsHorizontalIcon';

/**
 * author: Google
 * id 2E6100FD-8F6C-423C-BC18-372F8D57DC59
 * name blinds-horizontal
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blinds-horizontal.svg
 * tags
 * - Home Automation 
 */
export const MiniBlindsIcon = BlindsHorizontalIcon;
export default MiniBlindsIcon